/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconExposure0 = createReactComponent("outline", "exposure-0", "IconExposure0", [["path", { "d": "M12 19a4 4 0 0 0 4 -4v-6a4 4 0 1 0 -8 0v6a4 4 0 0 0 4 4z", "key": "svg-0" }]]);

export { IconExposure0 as default };
//# sourceMappingURL=IconExposure0.mjs.map
